import IApiClient from "./ApiClient";
import {UserAccessResponse} from "models/UserAccess"

export interface IUserAccessService {
    getUserAccess(phonenumber: string): Promise<UserAccessResponse | undefined>;
  }

export default class UserAccessService implements IUserAccessService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/useraccess';
      this.apiClient = apiClient;
    }
  
    async getUserAccess(phonenumber: string): Promise<UserAccessResponse|undefined> {
      try {
        const response = await this.apiClient.get<UserAccessResponse>(
          `${this.apiBase}/getaccess/${phonenumber}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }
  }